<div class="modal-header modal-title" appCustomAutofocus>
    <h4 class="">Actual Equipment</h4>
</div>
<div class="modal-body">
    <div class="row d-block d-lg-none" style="margin-bottom:10px;">
        <div class="col-lg-6 col-md-6 col-sm-12">
            <label><strong>Order By:</strong></label>
            <ng-select [(ngModel)]="formData.sortByValue"
                       [searchable]="false"
                       [clearable]="false"
                       (ngModelChange)="updateFilter()"
                       dropdownPosition="bottom">
                <ng-option *ngFor="let sortByOption of sortByOptions" [value]="sortByOption">{{sortByOption.title}}</ng-option>
            </ng-select>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-12" style="margin-bottom:10px;">
            <label><strong>Search:</strong></label>
            <input type="text" class="form-control" [(ngModel)]="searchString" (ngModelChange)="updateFilter()" />
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12">
            <label><strong>Only Show Unassigned Equipment: </strong></label>
            <input type="checkbox" class="form-control" [(ngModel)]="equipmentNotUsed" (change)="updateFilter()" style="width:25px; height:25px;top: 5px;position: relative;" />
        </div>
    </div>
    <br />
    <div class="row">
        <div class="col-lg-12">
            <table class="table table-responsive d-none d-lg-block">
                <thead>
                    <tr>
                        <th class="col-lg-3" (click)="setTableSorting('EquipmentDescription')">
                            <a href="#">
                                Equipment
                                <span class="modus-icons align-bottom" *ngIf="formData.sortByValue && formData.sortByValue.isDescending == false && formData.sortByValue.name == 'EquipmentDescription'">chevron_up_thick</span>
                                <span class="modus-icons align-bottom" *ngIf="formData.sortByValue && formData.sortByValue.isDescending == true && formData.sortByValue.name == 'EquipmentDescription'">chevron_down_thick</span>
                            </a>

                        </th>
                        <th class="col-lg-5" (click)="setTableSorting('Job')">
                            <a href="#">
                                Current Job
                                <span class="modus-icons align-bottom" *ngIf="formData.sortByValue && formData.sortByValue.isDescending == false && formData.sortByValue.name == 'Job'">chevron_up_thick</span>
                                <span class="modus-icons align-bottom" *ngIf="formData.sortByValue && formData.sortByValue.isDescending == true && formData.sortByValue.name == 'Job'">chevron_down_thick</span>
                            </a>

                        </th>
                        <th class="col-lg-2" (click)="setTableSorting('TransferDate')">
                            <a href="#">
                                Last Transfer
                                <span class="modus-icons align-bottom" *ngIf="formData.sortByValue && formData.sortByValue.isDescending == false && formData.sortByValue.name == 'TransferDate'">chevron_up_thick</span>
                                <span class="modus-icons align-bottom" *ngIf="formData.sortByValue && formData.sortByValue.isDescending == true && formData.sortByValue.name == 'TransferDate'">chevron_down_thick</span>
                            </a>

                        </th>
                        <th class="col-lg-1" (click)="setTableSorting('EstReturnDate')">
                            <a href="#">
                                Est Return
                                <span class="modus-icons align-bottom" *ngIf="formData.sortByValue && formData.sortByValue.isDescending == false && formData.sortByValue.name == 'EstReturnDate'">chevron_up_thick</span>
                                <span class="modus-icons align-bottom" *ngIf="formData.sortByValue && formData.sortByValue.isDescending == true && formData.sortByValue.name == 'EstReturnDate'">chevron_down_thick</span>
                            </a>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let equipment of shownEquipments;">
                        <td>
                            <button class="btn btn-md btn-success" (click)="useSelected(equipment)">{{equipment.EquipmentDescription}}</button>
                        </td>
                        <td>
                            {{equipment.Job}}{{equipment.JobDescription}}
                        </td>
                        <td>
                            {{equipment.TransferDateDisplay}}
                        </td>
                        <td>
                            {{equipment.EstReturnDateDisplay}}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <div class="d-block d-lg-none">
        <div class="row">
            <div class="col-md-12">
                <div *ngFor="let equipment of shownEquipments; let $last=last">

                    <div class="row" style="margin-bottom:10px;">
                        <div class="col-md-6 col-sm-12">
                            <button class="btn btn-sm btn-success" (click)="useSelected(equipment)">
                                {{equipment.EquipmentDescription}}
                            </button>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6 col-sm-12">
                            <label>Job: </label>{{equipment.Job}}{{equipment.JobDescription}}
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6 col-sm-12">
                            <label>Transfer Date: </label>{{equipment.TransferDateDisplay}}
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6 col-sm-12">
                            <label>Estimate Return: </label>{{equipment.EstReturnDateDisplay}}
                        </div>
                    </div>
                    <hr *ngIf="!$last" />
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-12">
            <pagination [totalItems]="filteredEquipments?.length"
                        class="pagination-sm"
                        [(ngModel)]="formData.currentPage"
                        (ngModelChange)="setPage()"
                        [itemsPerPage]="formData.itemsPerPage"
                        [maxSize]="10">
            </pagination>
        </div>
    </div>
    <div class="modal-footer">
        <button (click)="cancel()" class="btn btn-outline-dark">Cancel</button>
    </div>
</div>
